<template>
  <div class="payment">
    <div class="payment-title">
      <span>捐款已成功</span>
      <span>感谢您的爱心</span>
    </div>
    <div class="payment-img">
      <img :src="certimg" alt="">
    </div>
    <div class="down">
      长按图片下载证书
    </div>
    <div class="cert-icon">
      <van-icon name="close" @click="closeIcon" />
    </div>
<!--    <div class="completed" @click="complete()"><span>查看证书</span></div>-->
  </div>
</template>

<script>
import {genLoveCert} from "../../api";
import {Toast} from "vant";

export default {
  name: "payCompleted",
  data(){
    return{
      certimg:''
    }
  },
  created() {
    this.getcert()
  },
  methods:{
    async getcert(){
      Toast.loading({
        duration: 0,
        message: '证书生成中...',
        forbidClick: true,
      });
      let id = window.localStorage.getItem('ordId')
      const data = await genLoveCert({ordId:id})
      if(data.code == 200){
        this.certimg =data.data.certUrl
      }
      Toast.loading({
        duration: 100,
        message: '已完成...',
        forbidClick: true,
      });

    },
    closeIcon(){
      this.$router.push({path:'/library',query:{proId:3,certid:2}})
    }
    // complete(){
    //   this.$router.push('/cert')
    // }
  }
}
</script>

<style scoped lang="scss">
.payment {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: url('../../assets/completed.jpg');
  background-size: cover;
  color: #FFFFFF;
  text-align: center;
  box-sizing: border-box;
  align-items: center;
  //justify-content: center;

  span {
    font-size: 40px;
    display: block;
    margin-top: 10px;
  }

  .payment-title {
    padding-top: 50px;
    padding-bottom: 30px;
  }

  .payment-img {
    width: 650px;
    height: 882px;

    img {
      width: 650px;
      height: 882px;
      display: block;
    }
  }

  .completed {
    width: 300px;
    height: 100px;
    line-height: 100px;
    border-radius: 40px;
    background: #A471AA;
    border: 1px solid #FFFFFF;
    font-size: 30px;
    text-align: center;
    margin: 0 auto;
    margin-top: 100px;

    span {
      margin-top: 0;
    }
  }
  .down{
    margin-top: 40px;
  }
 .cert-icon{
    color:#EAEAF8;
    text-align: center;
    padding-top: 40px;
    font-size: 70px;
  }
}
</style>
